import React from 'react';

import TermsOfAdhesionContent from '@components/common/core/Utils/TermsOfAdhesionModal/TermsOfAdhesionContent';
import logo from '@assets/img/brand/profitfy-logo.svg';

import * as S from './styles';

const TermsOfAdhesion: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.Logo src={logo} alt="Profitfy.me" />
        <TermsOfAdhesionContent />
      </S.Content>
    </S.Container>
  );
};

export default TermsOfAdhesion;
